import { useConfig } from '@sanlam-glacier/app-common/providers';
import { ReactNode } from 'react';
import { FeatureFlagPath } from './FeatureFlags.type';
import { get } from 'lodash';

export const useFeature = (feature: FeatureFlagPath): boolean => {
  const { featureFlags } = useConfig();
  const isFeatureAllowed = get(featureFlags, feature);

  return isFeatureAllowed === true;
};

type NonEmptyFeatureFlags = readonly [FeatureFlagPath, ...FeatureFlagPath[]];

type FeatureResults<TFeatures extends NonEmptyFeatureFlags> = {
  [Index in keyof TFeatures]: boolean;
};

export const useFeatures = <TFeatures extends NonEmptyFeatureFlags>(
  features: TFeatures
): FeatureResults<TFeatures> => {
  const { featureFlags } = useConfig();

  return features.map(
    (feature) => get(featureFlags, feature) === true
  ) as FeatureResults<TFeatures>;
};

type FeatureToggleRouteProps = {
  component: ReactNode;
  fallback: ReactNode;
  feature: FeatureFlagPath;
};

export const FeatureToggleRoute = ({
  component,
  fallback,
  feature
}: FeatureToggleRouteProps): JSX.Element => {
  const featureEnabled = useFeature(feature);
  return <>{featureEnabled ? component : fallback}</>;
};
